import { ListGroup } from "react-bootstrap";
import { MdInsertPhoto } from "react-icons/md";

//satellite
import { ObbDet        } from "./api/Application";
import { showPercent   } from "./common/Percent";

export interface DetectionListEntryProps {
    vehicle:       ObbDet;
    onClick?:      () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export function DetectionListEntry( props: DetectionListEntryProps ) {
    function VehicleTable( { vehicle } : { vehicle: ObbDet } ) {
        return <div className="small">
            <table>
                <tbody>
                    <tr>
                        <td>
                            Width
                        </td>
                        <td className="text-end">
                            {vehicle.width}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Height
                        </td>
                        <td className="text-end">
                            {vehicle.height}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Conf
                        </td>
                        <td className="text-end">{showPercent( vehicle.confidence, 0 )}</td>
                    </tr>
                </tbody>
            </table>
        </div>;        
    }
    
    const vehicle = props.vehicle;
    return <ListGroup.Item
        className="p-2 mb-2 rounded d-flex align-items-center match-item border-1 p-4 bg-body shadow hover-highlight"
        onClick={props.onClick}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        style={{ cursor: "pointer" }}>
        <div className="position-relative d-flex flex-column align-items-center me-3 flex-shrink-0">
            <MdInsertPhoto className="img-px match-item-thumbnail" />
        </div>
        <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center gap-1 small fw-bold">
                #{vehicle.obbDetId} Detection
            </div>
            <div>
                <VehicleTable vehicle={vehicle} />
            </div>
        </div>
    </ListGroup.Item>;
}